module.exports = __webpack_public_path__ + "static/media/missionFray.81ee0870.svg";